import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"arrow-up\"><path d=\"M438.627 201.373l-160-160c-12.496-12.497-32.757-12.497-45.254 0l-160 160c-12.497 12.497-12.497 32.758 0 45.255s32.758 12.498 45.255 0L224 141.255V448c0 17.673 14.327 32 32 32s32-14.327 32-32V141.255l105.373 105.373C399.621 252.876 407.811 256 416 256s16.379-3.124 22.627-9.373c12.497-12.497 12.497-32.757 0-45.254z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-up.svg
// module id = AZ9S
// module chunks = 1